import template from './lvm-sales-game-list.html';

export default class LvmSalesGameList {
  constructor() {
    this.template = template;
    this.bindings = {
      games: '<',
      label: '<',
      header: '<',
      netSalesTotal: '<',
      isYear: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lvm-sales/components/lvm-sales-game-list/lvm-sales-game-list-component.js